export default class ZipArboController {
	/* @ngInject */
	/**
	 * @param {import('angular').IFilterService} $filter
	 * @param {any} $scope
	 */
	constructor($filter, $scope) {
		/**
		 * @type {any}
		 */
		this.formTreeData = undefined;
		this.showDetails = false;
		this.tree = undefined;
		this.treeOptions = {
			nodeChildren:  'dirs',
			dirSelectable: true,
			isLeaf: (/** @type {any} */ node) => 'type' in node && node.type === 'file',
			injectClasses: {
				ul:            'a1',
				li:            'a2',
				liSelected:    'a7',
				iExpanded:     'a3',
				iCollapsed:    'a4',
				iLeaf:         'a5',
				label:         'a6',
				labelSelected: 'a8',
			},
		};

		this.$filter = $filter;
		this.$scope = $scope;
	}

	/**
	 * @param {any} zip
	 * @returns {any[]}
	 */
	orderArbo(zip) {
		const tab = [];
		for (const [key, zipdir] of Object.entries(zip.dirs)) {
			const elt = { name: key, type: 'folder', dirs: this.orderArbo(zipdir) };
			tab.push(elt);
		}
		for (const zipfile of zip.files) {
			tab.push({
				name: zipfile.basename,
				type: 'file',
				path: zip.path,
				size: zipfile.size,
				date: new Date(zipfile.mtime * 1000),
			});
		}
		return tab;
	}

	/**
	 * @param {any} node
	 */
	showSelected(node) {
		if (node.type === 'file') {
			this.showDetails = true;
			this.selectedNode = node;
		}
		else {
			this.showDetails = false;
		}
	}

	/**
	 * @param {import('angular').IOnChangesObject} changes
	 */
	$onChanges(changes) {
		if (changes.formTreeData && this.formTreeData) {
			this.tree = this.orderArbo(this.formTreeData);
		}
	}
}
